import { InfiniteList, TextField, Datagrid, NumberField, DateField, ReferenceField, useTranslate } from 'react-admin'
import ListResults from '../invoices/list/ListResults'
import DraftFilters from './DraftFilters'
import DraftBulkActionButtons from './DraftBulkActionButtons'
import DraftListActions from './DraftListActions'

const DraftList = () => {
  const translate = useTranslate()

  return (
    <InfiniteList filters={DraftFilters} actions={<DraftListActions />} sort={{field: "createdAt", order: "DESC"}} >
      <ListResults resource='drafts'/>
      <Datagrid rowClick='show' bulkActionButtons={<DraftBulkActionButtons />} >
        <TextField source="invoiceRecipient.company.companyName" label={'resources.company.companyName'} sortable={false} />
        <ReferenceField link="list" source="numberRangeId" reference='numberRanges' label={'resources.invoices.numberRange'} sortable={false} >
          <TextField source='name' />
        </ReferenceField>
        <NumberField source="grossAmount" label={'resources.invoices.grossAmount'} options={{ style: 'currency', currency: 'EUR' }} sortable={false} />
        <DateField source="dueDate" label={'resources.invoices.dueDate'} sortable={false} />
        <NumberField label={translate("resources.invoices.comment", {smart_count: 2})} source="comments.length" emptyText="0" sortable={false} />
      </Datagrid>
    </InfiniteList>
  )
}

export default DraftList